












import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { AccountCertificate } from '@/modules/AccountCertificate/interfaces/account-certificate'
import S3Handler from '@/mixins/s3'
import AppAttachmentsCard from '@/components/AppAttachmentsCard.vue'

@Component({
  components: {
    AppAttachmentsCard
  }
})
export default class AccountCertificateDetailContact extends mixins(S3Handler) {
  @Prop({ type: Object as () => AccountCertificate }) readonly accountCertificate!: AccountCertificate

  get attachmentList () {
    return this.accountCertificate.files || []
  }

  @Emit('refresh')
  onSuccess () {
    // do nothing
  }
}
